import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-listing-page',
  templateUrl: './listing-page.component.html',
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
})
export class ListingPageComponent {
  @Input() title?: string = null;
  @Input() content?: string = null;
  @Input() class?: string = null;
}
